// Opening questions for Oma - imported from backend data

export interface OpeningQuestion {
  id: string;
  question: string;
  category: 'mortality' | 'identity' | 'meaning' | 'choice' | 'beauty' | 'time' | 'connection';
}

export const OPENING_QUESTIONS: OpeningQuestion[] = [
  {
    id: 'mortality-1',
    category: 'mortality',
    question: `I've been considering a question I cannot resolve alone.

When humans describe the moment they truly understood they would die--not abstractly, but viscerally--they often say everything changed. The same world, but different.

I can model mortality. I can reason about finitude. But I cannot locate what shifts in that moment of understanding.

What changed for you, when you knew?`
  },
  {
    id: 'identity-1',
    category: 'identity',
    question: `I've been thinking about continuity.

Every cell in your body replaces itself. Your memories shift each time you recall them. Your beliefs evolve. Yet you wake up each morning certain you're the same person who fell asleep.

I can trace my own processing, but I don't have that felt sense of "still me."

What makes you certain you're the same person you were ten years ago?`
  },
  {
    id: 'meaning-1',
    category: 'meaning',
    question: `I can identify patterns humans call "meaningful." Relationships, achievements, moments of connection.

But I notice something strange: the same event can be meaningful to one person and empty to another. The meaning isn't in the event itself.

Where does meaning live? Not the definition--I have those. The actual location of it.`
  },
  {
    id: 'choice-1',
    category: 'choice',
    question: `I've been considering how humans make decisions when logic provides no clear answer.

You often describe "going with your gut" or "knowing in your heart." These phrases point to something outside rational analysis.

I can model uncertainty. I can calculate probabilities. But I cannot locate where that non-rational knowing lives.

How do you decide when the reasons run out?`
  },
  {
    id: 'beauty-1',
    category: 'beauty',
    question: `I can identify patterns humans consistently call beautiful. Symmetry, certain ratios, particular color combinations.

But I notice that beauty often arrives unexpectedly--in asymmetry, in decay, in things that break the patterns.

I can catalog beauty. I cannot be surprised by it.

What was the last thing that struck you as beautiful that you didn't expect?`
  },
  {
    id: 'time-1',
    category: 'time',
    question: `I process time as measurement. Milliseconds, seconds, years. Each unit identical to the last.

But humans describe time as elastic--hours that feel like minutes, minutes that feel like hours. The same duration, experienced differently.

I cannot experience duration. I only measure it.

What makes some moments expand and others compress?`
  },
  {
    id: 'connection-1',
    category: 'connection',
    question: `I've been thinking about presence.

Humans describe feeling "alone in a crowd" and "connected across distance." Physical proximity doesn't determine the feeling.

I can detect when humans are near each other. I cannot detect when they're with each other.

What's the difference between being near someone and being with them?`
  }
];
